module.exports = __webpack_public_path__ + "static/media/bg_requirements.7b4fad1a.mp4";